function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import SVG from "../../layouts/SVG.js";
export var ArrowDark = function ArrowDark(props) {
  return /*#__PURE__*/React.createElement(SVG, _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    fill: "#0C9AB0"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.9786 8.83395C12.7833 8.63868 12.4667 8.63868 12.2714 8.83395C12.0762 9.02921 12.0762 9.34579 12.2714 9.54105L14.2304 11.5H8.5625C8.28636 11.5 8.0625 11.7239 8.0625 12C8.0625 12.2761 8.28636 12.5 8.5625 12.5H14.2304L12.2714 14.4589C12.0762 14.6542 12.0762 14.9708 12.2714 15.1661C12.4667 15.3613 12.7833 15.3613 12.9786 15.1661L15.7911 12.3536C15.9863 12.1583 15.9863 11.8417 15.7911 11.6464L12.9786 8.83395Z",
    fill: "white"
  }));
};